// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Homepage from './Homepage';
import LoginAndAuthentication from './LoginAndAuthentication';
import RequirementsPortal from './RequirementsPortal';
import BusinessTeams from './BusinessTeams';
import FunctionalLevels from './FunctionalLevels';
import FunctionalAttributes from './KeyFunctionalAttributes';
import IntegrationSystems from './IntegrationSystems';
import BaseRequirementsManagement from './BaseRequirementsManagement';
import IntegrationRequirementsManagement from './IntegrationRequirementsManagement';
import ManageProducts from './ManageProducts';
import RaidLogManagement from './RaidLogManagement';
import MyRequirementApprovals from './MyRequirementApprovals';
import ManageUsers from './ManageUsers';
import FunctionalDomains from './FunctionalDomains';
import ManageProjects from './ManageProjects';
import ManageStatusCodes from './ManageStatusCodes';
import ManageAccessLevels from './ManageAccessLevels';
import UserRolesDefinition from './UserRolesDefinition';
import SubmitFeedback from './SubmitFeedback';
import UpdateUserAccount from './UpdateUserAccount';
import StatusPriorityReport from './StatusPriorityReport';
import RequirementApprovalDashboard from './RequirementApprovalDashboard';
import ProductClassificationReport from './ProductClassificationReport';
import PricingPage from './Pricing';

const App = () => {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/login" element={<LoginAndAuthentication />} />
          <Route path="/LoginAndAuthentication" element={<LoginAndAuthentication />} />
          <Route path="/RequirementsPortal" element={<RequirementsPortal />} />
          <Route path="/BusinessTeams" element={<BusinessTeams />} />
          <Route path="/FunctionalLevels" element={<FunctionalLevels />} />
          <Route path="/FunctionalAttributes" element={<FunctionalAttributes />} />
          <Route path="/IntegrationSystems" element={<IntegrationSystems />} />
          <Route path="/BaseRequirementsManagement" element={<BaseRequirementsManagement />} />
          <Route path="/IntegrationRequirementsManagement" element={<IntegrationRequirementsManagement />} />
          <Route path="/ManageProducts" element={<ManageProducts />} />
          <Route path="/RaidLogManagement" element={<RaidLogManagement />} />
          <Route path="/MyRequirementApprovals" element={<MyRequirementApprovals />} />
          <Route path="/ManageUsers" element={<ManageUsers />} />
          <Route path="/FunctionalDomains" element={<FunctionalDomains />} />
          <Route path="/ManageProjects" element={<ManageProjects />} />
          <Route path="/ManageStatusCodes" element={<ManageStatusCodes />} />
          <Route path="/ManageAccessLevels" element={<ManageAccessLevels />} />
          <Route path="/UserRolesDefinition" element={<UserRolesDefinition />} />
          <Route path="/feedback" element={<SubmitFeedback />} />
          <Route path="/UpdateUserAccount" element={<UpdateUserAccount />} />
            <Route path="/StatusPriorityReport" element={<StatusPriorityReport />} />
            <Route path="/RequirementApprovalDashboard" element={<RequirementApprovalDashboard />} />
            <Route path="/ProductClassificationReport" element={<ProductClassificationReport />} />
            <Route path="/Pricing" element={<PricingPage />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;